import { useSearchParams } from 'react-router-dom';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { ia } from 'lib/helpers/utility';

import EmptyDataRows from 'components/shared/AgTablePage/components/EmptyDataRows';
import Button from 'components/shared/Button/Button';
import { getActiveFilters } from 'components/shared/Filters/lib/helpers';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const EmptyProviderState = ({ addProvider, isInNetwork, addProviderButton }) => {
  const { filters, updateFilters } = useTableContext();
  const [_, setSearchParams] = useSearchParams();

  const hasActiveFilters = ia(getActiveFilters(filters));

  if (hasActiveFilters) {
    return (
      <div className="flex flex-col items-center gap-1 px-4 py-10">
        <Icon icon="illustration-empty-table" />

        <Typography weight={600} size="base" className="text-primary-900">
          No results match your filters
        </Typography>

        <Typography weight={400} size="small" color="neutral-600">
          Adjust the filters to see more results.
        </Typography>

        <Button
          text="Clear Filters"
          icon="close-square-mono"
          variant="link"
          size="xs"
          onClick={() => {
            setSearchParams({});
            updateFilters(null);
          }}
        />
      </div>
    );
  }

  const title = addProvider
    ? 'All providers have already been added'
    : isInNetwork
      ? 'No in-network providers added yet'
      : 'No out-of-network providers added yet';

  const description = addProvider
    ? 'There are no more providers available to add. All practice providers are already in this list.'
    : isInNetwork
      ? 'This provider has an agreement with certain insurance plans. Visits are typically covered at a lower cost when your insurance is in-network. If your plan is not in-network, you may be responsible for a higher portion of the cost.'
      : 'This provider does not have an agreement with your insurance plan. Your visit may not be fully covered, and you may be responsible for a higher copay or the full cost.';

  return (
    <EmptyDataRows
      title={title}
      description={description}
      buttonComponent={addProviderButton}
      isButton={!addProvider}
    />
  );
};

export default EmptyProviderState;
